import { StyleSheet } from 'react-native';
import { STYLE_VARS } from '../../../constants/style-vars';
import { COLORS, FONTS } from '../../../constants';

export const styles = StyleSheet.create({
  wrapper: {
    paddingVertical: 20,
    paddingHorizontal: 20,
  },
  detailWrapper: {
    flexDirection: 'row',
  },
  backOption: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 100,
    width: 30,
    height: 30,
    justifyContent: 'center',
    alignItems: 'center',
  },
  backIcon: {
    width: 20,
    height: 20,
  },
  thumbnailWrapper: {
    alignItems: 'center',
    flex: 1,
  },
  thumbnail: {
    width: '90%',
    height: 300,
    resizeMode: 'contain',
    zIndex: 10,
  },
  contentText: {
    paddingVertical: 24,
  },
  contentName: {
    fontSize: 20,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    letterSpacing: 2,
    color: STYLE_VARS.primaryColor,
    textTransform: 'uppercase',
    fontWeight: '500',
    marginBottom: 10,
  },
  contentDesc: {
    fontSize: 14,
    fontFamily: STYLE_VARS.avenirMediumFont,
    color: '#606060',
    textTransform: 'uppercase',
    fontWeight: '500',
    marginBottom: 10,
  },
  priceText: {
    paddingTop: 8,
    fontSize: 20,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    letterSpacing: 2,
    color: STYLE_VARS.primaryColor,
    textTransform: 'uppercase',
    fontWeight: '600',
  },
  countWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  count: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  countBtn: {
    width: 30,
    height: 30,
    borderWidth: 1,
    borderColor: STYLE_VARS.fccDarkGrey,
  },
  countBtnText: {
    color: COLORS.BLACK,
    textAlign: 'center',
    fontSize: 18,
  },
  countText: {
    fontSize: 20,
    paddingHorizontal: 16,
    color: COLORS.BLACK,
    fontFamily: STYLE_VARS.avenirMediumFont,
  },
  addToCardBtn: {
    backgroundColor: STYLE_VARS.primaryColor,
    flexDirection: 'row',
    paddingVertical: 10,
    paddingHorizontal: 18,
    alignItems: 'center',
    gap: 8,
    borderRadius: 8,
  },
  addToCardText: {
    fontSize: 14,
    fontWeight: '800',
    fontFamily: STYLE_VARS.avenirMediumFont,
    letterSpacing: 1,
    color: STYLE_VARS.fccWhite,
    textTransform: 'uppercase',
  },
  addToCardIcon: {
    width: 16,
    height: 16,
  },
  similarProductsWrp: {
    paddingVertical: 40,
  },
  similarProductsText: {
    fontSize: 20,
    letterSpacing: 2,
    fontFamily: STYLE_VARS.iowanOldStyleFont,
    textAlign: 'center',
    textTransform: 'uppercase',
    color: STYLE_VARS.primaryColor,
    paddingBottom: 20,
  },
  tableHeaderText: {
    fontFamily: FONTS.AvenirMedium,
    fontSize: 15,
    textTransform: 'uppercase',
    color: COLORS.GREEN,
    padding: 10,
  },
});
